import { useEffect } from 'react';

declare global {
  interface Window {
    NavatticEmbed?: {
      initPopups?: () => void;
      [key: string]: unknown;
    };
  }
}

export default function useNavattic(typename: string) {
  useEffect(() => {
    if (typename !== 'kontent_item_link_action_navattic_pop_up' && window !== undefined) {
      const scriptId = 'navattic-embed-script';
      const existingScript = document.getElementById(scriptId);
      const initializeNavattic = () => {
        if (window?.NavatticEmbed && typeof window.NavatticEmbed.initPopups === 'function') {
          window.NavatticEmbed.initPopups();
        }
      };
      if (!existingScript) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://js.navattic.com/embeds.js';
        script.async = true;
        script.onload = initializeNavattic;
        document.body.appendChild(script);
      } else {
        initializeNavattic();
      }
    }
  }, [typename]);
}
